import {
  OnboardingDashboard,
  mapOnboardingRows,
} from "@/components/TrialEnrollment/OnboardingPlots";

export default function EnrollmentMetricsTab({
  data = [],
}: {
  data?: Record<string, unknown>[];
}) {
  const rows = mapOnboardingRows(data);

  return (
    <div className="px-4 py-4">
      <div className="mb-6">
        <h2 className="text-[18px] font-semibold text-[#2B4752] m-0">
          Enrollment - Expectation vs Actual
        </h2>
        <p className="text-[13px] text-[#6b8089] mt-1 mb-0">
          Actuals from the Vivo core data model; plan, scenario and forecast
          curves from the trial's enrollment plan.
        </p>
      </div>
      <OnboardingDashboard rows={rows} />
    </div>
  );
}
